module.exports = __webpack_public_path__ + "jo.e79e725e653d4369dc93.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/jo.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/jo.svg
// module chunks = styles